module.exports = __webpack_public_path__ + "static/screen-jaguar.2db698e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/screen-jaguar.jpg
// module id = 413
// module chunks = 114276838955818